import { render, staticRenderFns } from "./CreateAttachmentDialog.vue?vue&type=template&id=da9bb6fc"
import script from "./CreateAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./CreateAttachmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports